<template>
  <div v-if="tripid" class="trip-box">
    <span class="trip-label">Nezasa ID</span>
    <span class="trip-value">{{ tripid }}</span>

    <img
        src="@/assets/images/icons/copy.svg"
        class="copy-icon-img"
        @click="copyToClipboard(tripid)"
    />
  </div>
</template>
<script>
export default {
  name: "NezasaIdBox",
  props: {
    tripid: { type: String, required: true },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      const icon = event.currentTarget; // the SVG/icon element
      icon.classList.add('copy-animate');

      setTimeout(() => {
        icon.classList.remove('copy-animate');
      }, 300); // remove after animation
    },
  }
};
</script>
<style lang="scss" scoped>
.trip-box{
  position: absolute;
  min-width: 220px;
  max-width: 240px;
  height: 40px;
  right: 70px;
  top: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 6px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #F5F6FA;
  border-radius: 13px;
  padding: 11px 21px;
}
.trip-label {
  font-size: 12px;
  opacity: 0.7;
}
.trip-value {
  font-size: 14px;
  font-weight: 600;
}
.copy-icon-img {
  width: 12px;
  height: 12px;
  cursor: pointer;
  margin-left: 2px;
  opacity: 0.85;
  transition: 0.15s ease;
}
.copy-icon-img.copy-animate {
  animation: pop 0.3s ease-out;
}
.copy-icon-img:hover {
  opacity: 0.5;
  filter: brightness(0) saturate(100%) invert(20%);
}
@keyframes pop {
  0%   { transform: scale(1); }
  40%  { transform: scale(1.5); }
  100% { transform: scale(1); }
}
</style>